import { render } from "./SettingsTemplate.vue?vue&type=template&id=1bfc060d&ts=true"
import script from "./SettingsTemplate.vue?vue&type=script&lang=ts&setup=true"
export * from "./SettingsTemplate.vue?vue&type=script&lang=ts&setup=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/templates/SettingsTemplate.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1bfc060d"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1bfc060d', __exports__)) {
    api.reload('1bfc060d', __exports__)
  }
  
  module.hot.accept("./SettingsTemplate.vue?vue&type=template&id=1bfc060d&ts=true", () => {
    api.rerender('1bfc060d', render)
  })

}


export default __exports__